import {
  GET_WAREHOUSE_FILTER_OPTIONS,
  convertResult,
} from 'app/common/api/requests/food/warehouse/filter_options/get'

import { api } from 'app/api'

export const getWarehouseStockFilterOptions = async (signal?: AbortSignal) => {
  const res = await api.request(GET_WAREHOUSE_FILTER_OPTIONS, {
    additionalAxiosOptions: {
      signal,
    },
    error: 'Не удалось получить данные фильтров для остатков склада',
    convertions: {
      convertResult,
    },
  })

  return res
}
